/* istanbul ignore next */
export { default } from './SelectionModal';
